













































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TipDialog extends Vue {
  @Prop() private tip!: string;

  private value = '0';

  mounted(): void {
    if (this.tip) {
      this.value = this.tip;
    }
  }

  private get numberValue() {
    return Number(this.value);
  }

  private onInput(e: InputEvent) {
    const input: HTMLInputElement = e.target as HTMLInputElement;

    if (['.', '+', '-'].includes(e.data as string)) {
      input.value = '';
      input.value = this.value;
      return;
    }

    if (input.value[0] === '0') {
      this.value = Number(input.value).toString();
      input.value = this.value;
      return;
    }

    if (this.value.length === 1 && !e.data && !input.value) {
      this.value = '0';
      input.value = this.value;
      return;
    }

    this.value = input.value;
  }
}
